import { render, staticRenderFns } from "./admin-master-show.vue?vue&type=template&id=d0dc0cd8&scoped=true"
import script from "./admin-master-show.vue?vue&type=script&lang=js"
export * from "./admin-master-show.vue?vue&type=script&lang=js"
import style0 from "./admin-master-show.vue?vue&type=style&index=0&id=d0dc0cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dc0cd8",
  null
  
)

export default component.exports